import { render } from "./sales_and_purchase.vue?vue&type=template&id=1bcae216"
import script from "./sales_and_purchase.vue?vue&type=script&lang=js"
export * from "./sales_and_purchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__